<script lang="ts">
  import type { FolderNode } from '../lib/catalog';
  import { gallery } from '../lib/gallery.svelte';
  import Self from './FolderTree.svelte';

  let { node, depth = 0 }: { node: FolderNode; depth?: number } = $props();
</script>

<ul class="tree" class:root={depth === 0}>
  {#each node.children as child (child.path)}
    <li>
      {#if child.selectable}
        <button
          class="folder"
          class:active={gallery.listPath === child.path}
          style="padding-left: {0.75 + depth * 0.85}rem"
          onclick={() => gallery.selectFolder(child.path)}
        >
          {child.label}
        </button>
      {:else}
        <span class="group" style="padding-left: {0.75 + depth * 0.85}rem">{child.label}</span>
      {/if}
      {#if child.children.length}
        <Self node={child} depth={depth + 1} />
      {/if}
    </li>
  {/each}
</ul>

<style>
  .tree {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .folder,
  .group {
    display: block;
    width: 100%;
    text-align: left;
    padding: 0.5rem 0.75rem;
    font-size: 0.95rem;
    line-height: 1.2;
    border-radius: 6px;
    text-shadow: 0 1px 10px rgba(0, 0, 0, 0.55);
  }

  .folder {
    color: var(--fg);
    transition: background 0.15s var(--ease);
  }
  .folder:hover {
    background: rgba(255, 255, 255, 0.06);
  }
  .folder.active {
    background: rgba(255, 255, 255, 0.12);
    font-weight: 600;
  }

  .group {
    color: var(--muted);
    cursor: default;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 0.78rem;
  }
</style>
